// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cabinet-list-card {
  padding: 10px;
}
.menu-selectable-cabinets {
  padding-left: 30px;
}
.selectable-cabinet-list-item button {
  width: 30px;
  font-size: 14px;
}
.selectable-cabinet-list-items-available div {
  margin-left: 6px;
}
.cabinet-arcade-list-item {
  padding-top: 10px;
}
.cabinet-arcade-list-item .menu-item {
  width: 100%;
}
.cabinet-arcade-list-item .menu-item .classes-fill {
  width: 90%;
}
.cabinet-arcade-list-item .menu-item .list-item-menu {
  width: 10%;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
